 import React from 'react';
 import { HiOutlineArrowLongLeft } from "react-icons/hi2";
 import { useNavigate } from 'react-router-dom';

 const BackButton = ({ path, pagename, state, onClick }) => {
     const navigate = useNavigate();

     const handleBackClick = (event) => {
         event.preventDefault(); 
         if (onClick) {
             onClick(event);
             return;
         }
         if (!path || path === '/') {
             window.history.back();
         } else {
             navigate(path, { state: state });
         }
     };

     return (
         <div className='flex items-center gap-2 ms-4'>
             <button
                 onClick={handleBackClick}
                 className="
                 p-1
                 bg-blue-100
                 text-blue-800
                 rounded-full
                 shadow-md
                 hover:bg-blue-200
                 focus:outline-none
                 focus:ring-2
                 focus:ring-blue-400
                 focus:ring-opacity-75
                 transition
                 duration-200
                 ease-in-out
                 flex items-center justify-center
                 min-h-[36px] h-9 w-9
                 "
                 aria-label="Go back"
             >
                 <HiOutlineArrowLongLeft size={24} className="rtl:rotate-180" />
             </button>
             {pagename && <p className='uppercase font-semibold' data-testid={`${pagename}-text`}>{pagename}</p>}
         </div>
     );
 };

 export default BackButton;
